// ═══════════════════════════════════════════════════════════════
// CONTRATOS — Listado de contratos por empresa
// ═══════════════════════════════════════════════════════════════
//
// Columnas de la tabla del Listado. El renderizado de celdas personalizadas
// (badge de estatus, botón "Ver") se inyecta desde la página vía la función
// `format` de cada columna, para no acoplar el diseño aquí.

export const contractsColumns = [
  { name: 'company_name', label: 'Empresa', minWidth: 140, align: 'center' },
  { name: 'validity', label: 'Vigencia', minWidth: 200, align: 'center' },
  { name: 'status_badge', label: 'Estatus', minWidth: 110, align: 'center' },
  { name: 'mode_label', label: 'Modo', minWidth: 120, align: 'center' },
  { name: 'purchased', label: 'Comprado', minWidth: 100, align: 'center' },
  { name: 'assigned', label: 'Asignado', minWidth: 100, align: 'center' },
  { name: 'available', label: 'Disponible', minWidth: 100, align: 'center' },
  { name: 'actions', label: '', minWidth: 90, align: 'center' },
];

// ═══════════════════════════════════════════════════════════════
// CONTRATOS — Desglose por membresía (detalle · modo "con desglose")
// ═══════════════════════════════════════════════════════════════

export const contractLinesColumns = [
  { name: 'membership', label: 'Membresía', minWidth: 140, align: 'center' },
  { name: 'purchased', label: 'Compradas', minWidth: 110, align: 'center' },
  { name: 'assigned', label: 'Asignadas', minWidth: 110, align: 'center' },
];

// ═══════════════════════════════════════════════════════════════
// CONSUMO — Contrato con desglose
// ═══════════════════════════════════════════════════════════════

export const usageDetailedColumns = [
  { name: 'membership', label: 'Membresía', minWidth: 140, align: 'center' },
  { name: 'purchased', label: 'Compradas', minWidth: 110, align: 'center' },
  { name: 'assigned', label: 'Asignadas', minWidth: 110, align: 'center' },
  { name: 'available', label: 'Disponibles', minWidth: 120, align: 'center' },
];

// ═══════════════════════════════════════════════════════════════
// CONSUMO — Contrato solo total (muestra tipo y que descuenta del total)
// ═══════════════════════════════════════════════════════════════

export const usageTotalOnlyColumns = [
  { name: 'membership', label: 'Membresía', minWidth: 160, align: 'center' },
  { name: 'type', label: 'Tipo', minWidth: 100, align: 'center' },
  { name: 'purchased_by_type', label: 'Compradas por tipo', minWidth: 170, align: 'center' },
  { name: 'assigned', label: 'Asignadas', minWidth: 150, align: 'center' },
];

// ═══════════════════════════════════════════════════════════════
// CONTRATOS — Bitácora de modificaciones
// ═══════════════════════════════════════════════════════════════

export const contractLogColumns = [
  { name: 'date', label: 'Fecha', minWidth: 150, align: 'center' },
  { name: 'user', label: 'Usuario interno', minWidth: 150, align: 'center' },
  { name: 'change', label: 'Cambio', minWidth: 160, align: 'center' },
  { name: 'previous', label: 'Anterior', minWidth: 140, align: 'center' },
  { name: 'next', label: 'Nuevo', minWidth: 160, align: 'center' },
];
